import utils from '../../utils/util';
export class DealerShareBuilder {
  constructor ({ dealerInfo, shareInfo }) {
    this.dealerInfo = dealerInfo;
    this.shareInfo = shareInfo;
  }
  getPvareaId () {
    let pvAreaId = 2594117;
    if (utils.browser.isApp) {
      pvAreaId = 2594111;
    } else if (utils.browser.isPriceApp) {
      pvAreaId = utils.browser.isIos ? 2594113 : 2594114;
    }
    return pvAreaId;
  }
  buildShareData () {
    const dealerName = this.dealerInfo.dealerName;
    const shareInfo = this.shareInfo;
    const title = `「${dealerName}」带您线上逛店，看车问价一站式服务。`;
    let pvAreaId = this.getPvareaId();
    let link = window.location.origin + window.location.pathname + '?pvareaid=' + pvAreaId;
    return { title, icon: shareInfo && shareInfo.dealerImage, link };
  }
}